import App from './App';
import { createRoot } from "react-dom/client";
import {createBrowserRouter,RouterProvider,} from "react-router-dom";
import { AllData } from './Data/AllData';
import About from './About/About';
import Contact from './Contact/Contact';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App/>,
  },
  {
    path: "about",
    element: <About/>,
  },
  {
    path: "contact",
    element: <Contact/>,
  },
]);

createRoot(document.getElementById("root")).render(
  <AllData>

  <RouterProvider router={router} />
  </AllData>
);


